export default __webpack_public_path__ + "static/media/about-3.d508c8aa.png";